import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { ServiceService } from '@services/service.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { SaveService } from '@services/save.service';
import { CategoryService } from '@services/category.service';
import { SearchService } from '@services/search.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import { MapsAPILoader } from "@agm/core";
import * as _ from 'lodash';
import { google } from "google-maps";
declare var google: google;
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { CommonPipe } from '@pipes/common.pipe';
import { DatePipe } from '@angular/common';
import {DateService} from 'ngx-datetime-picker';
@Component({
  selector: 'app-eevent',
  templateUrl: './eevent.component.html',
  styleUrls: ['./eevent.component.sass']
})
export class EeventComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  public cconfig: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  is_owner=false;
  params:any=[];
  appEditForm: FormGroup;
  application = "";
  country="";
  component = "";
  category="";
  location_response:any=[];
  pathToMedia: any = {};
  image_paths: any = [];
  privacy_list: any = [];
  country_code="";
  timezone_list: any = [];
  location_list: any = [];
  country_list: any = [];
  status_list: any = [];
  host_list:any=[];
  error: any = {location:'',startDate:'',endDate:'',countryCode:'',name:'', categoryJson: '', country: '', timeZone: '', 'title': '', 'startTime': '', 'endTime': '', streetAddress: '', city: '', state: '', zip: '', category: '', email: '', description: '', privacy: '' };
  selected_category = "";
  lat = 0;
  location='';
  btn_process=false;
  lng = 0;
  response:any=[];
  id="";
  min=null;
  map_details: any = { lat: '', lng: '', label: 'L', info: '' };
  constructor( private dateService: DateService,private datePipe: DatePipe, private _searchService: SearchService,private ngZone: NgZone, private MapsAPILoader: MapsAPILoader,private _service: ServiceService,private _categoryService: CategoryService, private _commonPipe: CommonPipe, private _viewService: ViewService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SB;
    this.application = "event";
    this.appEditForm = this.fb.group({
      status: [],
      locationId: [],
      url: [],
      streetAddress: [],
      city: [],
      state: [],
      countryCode: [],
      zip: [],
      hostName: [],
      address: [],
      timeZone: [],
      title: [],
      startTime: [],
      endTime: [],
      email: [],
      hostId: [],
      hostDescription: [],
      goal: [],
      description: [],
      requirement: []
    });
    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.id = this.params['id'];
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            this.image_paths.push(this.pathToMedia);
            if(this.is_owner){
            this.min=new Date(this.response.startTime);
            this.appEditForm.get("startTime").setValue(new Date(this.response.startTime)); 
            this.appEditForm.get("endTime").setValue(new Date(this.response.endTime)); 
            this.appEditForm.get("timeZone").setValue(this.response.timeZone); 
            this.appEditForm.get("locationId").setValue(this.response.locationId); 
            let THIS = this;
            if(this.response.locationId){
              this.getLocation(this.response.locationId);
            }
            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);
               
                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });

                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
           
          }else{
            this.router.navigate(['']);
          }
        }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });
    let f = {
      'component': this.component,
      'application': this.application
    };

    this._formdataService.countries(f).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.country_list=this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'time').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.timezone_list = this._global.getVal(data, 'response.timeZone', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      }); 
     
        let s={
          'component': this.component,
          'application': 'location',
          'sortOrder': 'desc',
          'status': 'active',
          'sortString': 'createdTime',
          "start": 0,
          "rows": 100
         };
        this._searchService.application(s).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
              this.location_list=this._global.getVal(data, 'response.docs', '');
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
          this.hostView();
  }
  @ViewChild('streetAddress',{static:false}) public addressElement: ElementRef;
  @ViewChild('logo') public logo: ElementRef;
  ngOnInit() {
  }
  getDialCode(event) {
    let res = this.country_list.find(x => x.value == event);
    this.country = this._global.getVal(res,"name",'');
    this.country_code = this.appEditForm.value["countryCode"];

  }
  getLocation(event) {
    let l = {
      'component': this.component,
      'application': 'location',
      'id': event
    };
    this._viewService.application(l).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.location_response = this._global.getVal(data, 'response', '');
          this.appEditForm.get("countryCode").setValue(this.location_response.countryCode);
          this.appEditForm.get("city").setValue(this.location_response.city);
          this.appEditForm.get("state").setValue(this.location_response.state);
          this.appEditForm.get("zip").setValue(this.location_response.zip);
          this.appEditForm.get("address").setValue(this.location_response.address);
          this.appEditForm.get("streetAddress").setValue(this.location_response.streetAddress);
          this.country_code = this.location_response.countryCode;
          let res = this.country_list.find(x => x.value == this.country_code);
          this.country = this._global.getVal(res,"name",'');
          this.getLatLan(this._global.getVal(this.location_response, 'streetAddress', ''));
          this.map_details['info'] = this._global.getVal(this.location_response, 'streetAddress', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  returnZero() {
    return 0
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  public conUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public conUploadSuccess(args: any): void {
    this.logo.nativeElement.src = this._commonPipe.transform(this.response, ['image', this.application, 'id', 'title', 'm']);
  }
  public cancel(){
    this.router.navigate(['/my/event']);
  }
  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
    this.image_paths = [];
    this.image_paths.push(this.pathToMedia);
  }
  public conUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this.id);
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');
  }
  update() {
    this.error= {location:'',startDate:'',endDate:'',countryCode:'',name:'', categoryJson: '', country: '', timeZone: '', 'title': '', 'startTime': '', 'endTime': '', streetAddress: '', city: '', state: '', zip: '', category: '', email: '', description: '', privacy: '' };
    this.btn_process = true;
    let r = this.appEditForm.value;
    r.component = this.component;
    r.application = this.application;
    r = this._global.paramsRemoveNull(r);
    r.id = this.response.id;
    r.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');

    r = this._global.paramsRemoveNull(r);
    if (r.startTime) {
      r.startTime = new Date(r.startTime).getTime();
    }
    if (r.endTime) {
      r.endTime = new Date(r.endTime).getTime();
    }
    r.id = this.response.id;
    r.pathToMedia = JSON.stringify(this.pathToMedia);
    this._saveService.appUpdate(r).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/my/event']);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {
            
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
            
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  getLatLan(address: string) {
    let THIS = this;
    this.MapsAPILoader.load().then(() => {
      console.log('google script loaded');
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          THIS.map_details['lat'] = results[0].geometry.location.lat();
          THIS.map_details['lng'] = results[0].geometry.location.lng();
        } else {

        }
      });
    });
  }
  hostView() {
    let l = {
      'component': this.component,
      'application': 'member',
      'id': this._global.getSessionVal('id')
    };
    this._viewService.application(l).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let r = this._global.getVal(data, 'response', '');
          this.appEditForm.get("hostName").setValue(r['firstName'] + ' ' + r['lastName']);
          this.appEditForm.get("hostDescription").setValue(r['description']);
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  
}

